import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SignInModal } from '../components/auth/SignInModal';
import { CliSection } from '../components/landing/CliSection';
import { CreditsSection } from '../components/landing/CreditsSection';
import { LandingCta } from '../components/landing/LandingCta';
import { LandingHero } from '../components/landing/LandingHero';
import { PublishSection } from '../components/landing/PublishSection';
import { ServicesSection } from '../components/landing/ServicesSection';
import { WorkspaceSection } from '../components/landing/WorkspaceSection';
import { useAuth } from '../contexts/AuthContext';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, isAnonymous } = useAuth();
  const [isSignInModalOpen, setIsSignInModalOpen] = useState(false);
  const [authMode, setAuthMode] = useState<'signin' | 'signup'>('signin');

  const openAuthModal = (mode: 'signin' | 'signup') => {
    setAuthMode(mode);
    setIsSignInModalOpen(true);
  };

  const handlePrimaryAction = () => {
    if (isAuthenticated && !isAnonymous) {
      navigate('/new-chat');
      return;
    }

    openAuthModal('signup');
  };

  return (
    <div className="min-h-screen bg-[#07111f] text-white">
      <LandingHero onSignIn={() => openAuthModal('signin')} onPrimaryAction={handlePrimaryAction} />
      <CreditsSection />
      <WorkspaceSection />
      <PublishSection />
      <ServicesSection />
      <CliSection />
      <LandingCta onPrimaryAction={handlePrimaryAction} />

      <SignInModal
        isOpen={isSignInModalOpen}
        initialMode={authMode}
        onClose={() => setIsSignInModalOpen(false)}
      />
    </div>
  );
};

export default LandingPage;
